import { Flame, Snowflake, Thermometer } from 'lucide-vue-next';
import type { Component } from 'vue';

import type { DealTimeToBuy } from '@/modules/dealPrivate/types/DealTimeToBuy.type';

export type DealTimeToBuyBadgeTier = 'hot' | 'warm' | 'cold';

export type DealTimeToBuyBadgePresentation = {
  tier: DealTimeToBuyBadgeTier;
  label: string;
  class: string;
  icon: Component;
};

const DEAL_TIME_TO_BUY_BADGE_CLASS: Record<DealTimeToBuyBadgeTier, string> = {
  hot: 'border-red-300 bg-red-50 text-red-800 dark:border-red-700 dark:bg-red-950/50 dark:text-red-200',
  warm: 'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-100',
  cold: 'border-sky-300 bg-sky-50 text-sky-900 dark:border-sky-700 dark:bg-sky-950/40 dark:text-sky-100',
};

const DEAL_TIME_TO_BUY_BADGE_LABEL: Record<DealTimeToBuyBadgeTier, string> = {
  hot: 'Lead Quente',
  warm: 'Lead Morno',
  cold: 'Lead Frio',
};

const DEAL_TIME_TO_BUY_BADGE_ICON: Record<DealTimeToBuyBadgeTier, Component> = {
  hot: Flame,
  warm: Thermometer,
  cold: Snowflake,
};

export function resolveDealTimeToBuyBadgeTier(
  timeToBuy: DealTimeToBuy | null | undefined,
): DealTimeToBuyBadgeTier | null {
  if (timeToBuy == null) return null;
  switch (timeToBuy) {
    case 'immediately':
    case 'withinAMonth':
      return 'hot';
    case 'withinThreeMonths':
      return 'warm';
    case 'aboveThreeMonths':
      return 'cold';
    default:
      return null;
  }
}

export function getDealTimeToBuyBadgePresentation(
  timeToBuy: DealTimeToBuy | null | undefined,
): DealTimeToBuyBadgePresentation | null {
  const tier = resolveDealTimeToBuyBadgeTier(timeToBuy);
  if (tier === null) return null;
  return {
    tier,
    label: DEAL_TIME_TO_BUY_BADGE_LABEL[tier],
    class: DEAL_TIME_TO_BUY_BADGE_CLASS[tier],
    icon: DEAL_TIME_TO_BUY_BADGE_ICON[tier],
  };
}
